import {CookieChangeWatcher} from "localstorage/cookie/CookieChangeWatcher";
import {LocalStorageChangeWatcher} from "localstorage/localstorage/LocalStorageChangeWatcher";
import {IndexedDBChangeWatcher} from "localstorage/indexedDB/IndexedDBChangeWatcher";
import {LoggingService} from "logging/LoggingService";
import {Assert} from "common/Assert";

export function LocalDataChangeWatcher() {

    let cookieChangeWatcher,
        localStorageChangeWatcher,
        indexedDBChangeWatcher;

    function init() {
        cookieChangeWatcher = new CookieChangeWatcher();
        localStorageChangeWatcher = new LocalStorageChangeWatcher();
        indexedDBChangeWatcher = new IndexedDBChangeWatcher();
    }

    init();

    return {
        startTimer: function( checkIntervalTime, eventId, data ) {

            Assert.checkArgumentType(  checkIntervalTime, "number" );
            if( !cookieChangeWatcher.startTimer( checkIntervalTime, eventId, data ) ) {
                return false;
            }

            if( !localStorageChangeWatcher.startTimer( checkIntervalTime, eventId, data ) ) {
                return false;
            }

            indexedDBChangeWatcher.startTimer( checkIntervalTime, eventId, data ).then( (succeeded) => {
                if( !succeeded ){
                    LoggingService.warning( "IndexedDB change watcher failed on initialization!" );
                }
            });

            return true;
        },

        stopTimer: function () {
            cookieChangeWatcher.stopTimer();
            localStorageChangeWatcher.stopTimer();
        }
    }
}
